/*
 * @Description: 
 * @Autor: lizi
 * @Date: 2019-09-21 16:16:29
 * @LastEditors: lizi
 * @LastEditTime: 2022-07-16 19:40:00
 * @FilePath: \registration-system-web\src\config\ApiConfig.js
 */
export default {
    apiServer:
        process.env.NODE_ENV === 'production'
        
            ? 'http://49.235.113.204:8080'
            : 'http://49.235.113.204:8080',
    imgUrl: ' http://192.168.0.104:8081/'
};